import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRdxDialog, provideRdxDialogConfig } from '@radix-ng/primitives/dialog';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authInterceptor, requestInterceptor } from '@app/core/interceptor/auth.interceptor';
import { initSentry, provideSentryErrorHandler, provideSentryUserSync } from '@app/core/utils/sentry-init.util';
import { provideMixpanelSessionSync } from '@app/core/analytics/mixpanel-init.util';
import { environment } from './environments/environment';

initSentry(environment.sentry);

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, requestInterceptor])),
    provideRdxDialogConfig(),
    provideRdxDialog(),
    provideSentryErrorHandler(),
    provideSentryUserSync(),
    provideMixpanelSessionSync(),
  ]
}).catch(err => console.error(err));